import { useContext } from "react";
import { FeatureContext } from "../../../Context";

import {Button, Table, Tbody, Td, Th, Thead, Tr} from '@chakra-ui/react';

const List = () => {
  const context = useContext(FeatureContext);
  return (
    <Table size='sm' marginY={2}>
      <Thead>
        <Tr>
          <Th>Title / Description</Th>
          <Th>slug</Th>
          <Th></Th>
        </Tr>
      </Thead>
      <Tbody>
        {context?.forms?.map((form, index) => <Tr key={form.slug + index}>
          <Td>
            {form.title}<br />
            <small>{form.description}</small>
          </Td>
          <Td>
            {form.slug}
          </Td>
          <Td textAlign={'right'}>
            <Button colorScheme='blue' mr={2} onClick={() => context?.onEditForm(form)}>Edit</Button>
            <Button colorScheme='red' onClick={() => context?.onDeleteForm(form)}>Delete</Button>
          </Td>
        </Tr>)}
      </Tbody>
    </Table>);
}

export default List;